import React, { useEffect, useRef } from "react";
import stampImage from "../image/BfiStamp.png";
import Logo from "../image/AasthLogo.png";
import { Button, Toolbar } from "@mui/material";
import { useParams } from "react-router-dom";
import moment from "moment";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import QRCode from "react-qr-code";
import { BASE_URL, DOMAIN } from "../../global";

const Sticker = ({ selectedFormID }) => {
  const elementRef = useRef(null);
  const { reportID } = useParams();
  const [newReportID, setNewReportID] = React.useState(
    reportID || selectedFormID
  );
  const [inputStates, setInputStates] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [templateId, setTemplateId] = React.useState(null);
  const [data, setFinalData] = React.useState({});

  const handlePrint = () => {
    const printContent = document.getElementById("formToPrint");
    const originalContents = document.body.innerHTML;

    if (printContent) {
      document.body.innerHTML = elementRef.current.innerHTML;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload();
    }
  };
  const fetchformReport = async (id) => {
    setLoading(true);
    try {
      const res = await axiosWithToken.get(`${BASE_URL}reportValues/${id}`);
      const data = res.data[0];
      setFinalData(data)

      setTemplateId(data?.templateId);

      if (!data || !data.templateValues) {
        console.log("Template data not found or invalid");
        return;
      }

      const dataObject = data.templateValues && JSON.parse(data.templateValues);

      const newDataObject = { ...dataObject };
      // delete newDataObject.reportDate;
      setInputStates(newDataObject);
    } catch (error) {
      console.error("Failed to fetch template: ", error);
    } finally {
      setLoading(false);
    }
  };

  function formatDate(value) {
    return moment.utc(value, moment.ISO_8601, true).isValid()
      ? moment.utc(value).format("DD/MM/YYYY")
      : value;
  }

  function findDueDate(value, monthsToAdd) {
    const formats = ["DD/MM/YYYY", "DD/MM/YYYY"];
    const parsedDate = moment(value, formats.concat(moment.ISO_8601), true);
  
    if (parsedDate.isValid()) {
      return parsedDate.add(monthsToAdd, "months").format("DD/MM/YYYY");
    }
  
    return value;
  }
  


  useEffect(() => {
    if (newReportID > 0) {
      fetchformReport(newReportID);
    }
  }, [newReportID]);

  return (
    <div
      style={{
        pageBreakInside: "avoid !important",
        width: "100%",
        height: "100%",
        marginTop: "10px",
      }}
    >
      <div
        style={{
          pageBreakInside: "avoid !important",
          marginTop: "20px",
        }}
      >
        <table
          style={{
            height: "100%",
            marginTop: "10px",
            pageBreakInside: "avoid",
          }}
        >
          <tbody id="singlebordertable">
            <tr>
              <td
                style={{
                  width: "100px",
                  padding: "2px",
                  display: "grid",
                  placeItems: "center",
                  height: "100%",
                  borderRight:"none",
                  borderBottom: "none",
                }}
              >
                <img style={{ height: "70px", width: "95%" }} src={Logo} />{" "}
              </td>
              <td
                colSpan={4}
                style={{
                  textAlign: "center",
                  padding: "2px",
                  borderBottom: "none",
                }}
              >
                <div>
                  <b
                    style={{
                      fontSize: "1rem",
                    }}
                  >
                    3SM TECH SOLUTION
                  </b>
                  <br />
                  <div style={{display:"flex"}}>
                  <div style={{width:"80%"}}>
                  <h6
                    style={{
                      fontSize: "11px",
                    }}
                  >
                    Office # 301, Samyak Galleria, Near Divisional Sports Complex, Sutgirani Chowk, Garkheda Rd, Aurangabad, Maharashtra - 431009
                  </h6>
                  </div>
                  <div style={{width:"20%", display:"grid", placeItems:"center"}}>
                  <QRCode
                    value={DOMAIN+`/#/printForm/${newReportID}/${data?.templateId}`}
                    align="center"
                    size={30}
                  />
                  </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                  borderRight:"none",
                  borderBottom: "none",
                }}
              >
               Type of Testing
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                  borderRight:"none",
                  borderBottom: "none",
                }}
              >
                Test Date
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                  borderBottom: "none",
                }}
              >
                Due Date
              </td>
            </tr>
          

            {templateId == 12 ? (
              <>    <tr>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                  borderRight:"none",
                  borderBottom: "none",
                }}
              >
                Ultrasonic Test
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                  borderRight:"none",
                  borderBottom: "none",
                }}
              >
                {inputStates["utrasonicTestDate"] ? moment(inputStates["utrasonicTestDate"]).format("DD/MM/YYYY") : ""}
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                {inputStates["certificateValidity"] ? moment(inputStates["certificateValidity"]).format("DD/MM/YYYY") : ""}
                {/* {inputStates["utrasonicExaminationDueDate"]} */}
              </td>
            </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                      borderRight:"none",
                      borderBottom: "none",
                    }}
                  >
                    Internal Test
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                      borderRight:"none",
                      borderBottom: "none",
                    }}
                  >
                    {inputStates["internalTestDate"]}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                      borderTop:"none",
                      borderBottom: "none",
                    }}
                  >
                    {inputStates["internalExaminationDueDate"]}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                      borderRight:"none",
                    }}
                  >
                    Hydraulic Test
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                      borderRight:"none"
                    }}
                  >
                    {inputStates["hydraulicTestDate"] ? moment(inputStates["hydraulicTestDate"]).format("DD/MM/YYYY") :""}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                    }}
                  >
                    {inputStates["certificateValidity"] ? moment(inputStates["certificateValidity"]).format("DD/MM/YYYY") : ""}
                    {/* {inputStates["hydraulicExaminationDueDate"]} */}
                  </td>
                </tr>
            
              </>
            ) : (
               <>
              <tr>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                  borderRight:"none",
                }}
              >
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                  borderRight:"none",
                }}
              >
                {inputStates["reportDate"] ? moment(inputStates["reportDate"]).format("DD/MM/YYYY") : ""}
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                {inputStates["certificateValidity"] ? moment(inputStates["certificateValidity"]).format("DD/MM/YYYY") : ""}
              </td>
            </tr>          
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Sticker;
